import { action } from 'typesafe-actions';
import { WebLauncherLandingActionTypes, WebLaunchRequest } from 'types';

export const getWebLaunchRequestStart = (uuid: string) =>
  action(WebLauncherLandingActionTypes.GET_WEB_LAUNCHER_START, uuid);
export const getWebLaunchRequestSuccess = (payload: WebLaunchRequest) =>
  action(WebLauncherLandingActionTypes.GET_WEB_LAUNCHER_SUCCESS, payload);
export const getWebLaunchRequestFailure = (payload: string) =>
  action(WebLauncherLandingActionTypes.GET_WEB_LAUNCHER_FAILURE, payload);

export const clearWebLaunchRequest = () =>
  action(WebLauncherLandingActionTypes.CLEAR_WEB_LAUNCHER);
